(function ($) {

	$('form.product-detail-select-variant').change(load_product_variant)

	function show_loading() {
		$('.product-detail__variants').css({
			"opacity": "0.5",
			"pointer-events": "none"
		})
	}

	let request;

	function load_product_variant(e) {

		e.preventDefault()

		// Abort previous request if is loading
		if (typeof request !== "undefined") {
			request.abort()
		}

		// Show loading
		show_loading()

		let $this = $(this);

		let data = $this.serializeArray().concat([
			{
				name: 'quantity',
				value: $this.parent().find('input[name="quantity"]').val()
			}
		]); // add quantity info to keep it between changes

		request = gp_ajax({
			url: ghostpress_params.ajax_url,
			type: "post",
			dataType: "json",
			data: data
		})
			.done((response, textStatus, jqXHR) => {
				jQuery(document).trigger('product_variant_detail_loaded')
			})
	}

})(jQuery);
